// Import action types.
import ActionType from '@app/redux/actions/types';
// Import states.
import { AppState } from '@app/redux/states';
// Import action.
import {
	Action,
} from 'redux';

// Import allowed endorsement date range reducers.
import {
	LoadAllowedEndorsementDateRangeReducer,
} from './AllowedEndorsementDateRangeReducers';

// Import app mode reducers.
import {
	AddAppModeReducer,
	RemoveAppModesReducer,
} from './AppModeReducers';

// Import claim reducers.
import {
	LoadClaimPerilsReducer,
	LoadPreviousClaimsReducer,
	SetNewClaimReducer,
	SetPreviousClaimsReducer
} from './ClaimReducers';

// Import disqualifiers text reducers.
import {
	LoadDisqualifiersTextReducer,
} from './DisqualifiersTextReducers';

// Import eligibility message priority reducers.
import {
	LoadEligibilityMessagePrioritiesReducer,
    SelectEligibilityMessagePriorityReducer,
    UnselectEligibilityMessagePriorityReducer
} from './EligibilityMessagePriorityReducers';

// Import endorsement reducers.
import {
	LoadEndorsementPossiblePerilsReducer,
	LoadEndorsementReducer,
} from './EndorsementReducers';

// Import endorsement eligibility status reducers.
import {
	LoadEndorsementEligibilityStatusReducer
} from './EndorsementEligibilityStatusReducers';

// Import main navigation link reducers.
import {
	LoadMainNavigationLinksReducer,
} from './MainNavigationLinkReducers';

// import min cost per square foot reducers
import {
	LoadMinCostPerSquareFootReducer,
	SelectMinCostPerSquareFootReducer,
	UnselectMinCostPerSquareFootReducer,
} from './MinCostPerSquareFootReducers';

// import min cost per square foot version reducers
import {
	LoadMinCostPerSquareFootVersionReducer,
	SelectMinCostPerSquareFootVersionReducer,
	UnselectMinCostPerSquareFootVersionReducer,
} from './MinCostPerSquareFootVersionReducers';

// Import new business application preliminary reducers.
import {
	ClearNewBusinessApplicationPreliminaryReducer,
	SaveNewBusinessApplicationPreliminaryPerilsReducer,
	SaveNewBusinessApplicationPreliminaryPropertyAddressReducer,
} from './NewBusinessApplicationPreliminaryReducers';

// Import new business application reducers.
import {
	LoadNewBusinessApplicationReducer,
	SelectNewBusinessBuildingReducer,
	UnselectNewBusinessBuildingReducer,
	SelectNewBusinessMortgageeReducer,
	UnselectNewBusinessMortgageeReducer,
	LoadPossibleNewBusinessDisclosureTextsReducer,
	LoadNewBusinessApplicationDocumentReducer,
	LoadNewBusinessBindingAuthorityEligibilityResultsReducer,
	LoadNewBusinessPossiblePerilsReducer,
} from './NewBusinessApplicationReducers';

// Import notification reducers.
import {
	AddNotificationReducer,
	DeleteNotificationsReducer,
	FlushNotificationsReducer,
} from './NotificationReducers';

// Import policy reducers.
import {
	LoadPolicyCopyEligiblityStatusReducer,
} from './PolicyReducers';

// Import policy note email reducers.
import {
	LoadPolicyNoteEmailsReducer,
} from './PolicyNoteEmailReducers';

// Import policy note reducers.
import {
	LoadPolicyNoteReducer,
	LoadPolicyNotesReducer,
	SelectPolicyNoteReducer,
	UnselectPolicyNoteReducer,
} from './PolicyNoteReducers';

// Import policy term year reducers.
import {
	LoadPolicyTermYearsReducer
} from './PolicyTermYearReducers';

// Import possible building use reducers.
import {
	LoadPossibleBuildingUsesReducer,
} from './PossibleBuildingUseReducers';

// Import possible construction type reducers.
import {
	LoadPossibleConstructionTypesReducer,
} from './PossibleConstructionTypeReducers';

// Import possible correspondence recvd or sent reducers.
import {
	LoadPossibleCorrespondenceRecvdOrSentReducer,
} from './PossibleCorrespondenceRecvdOrSentReducers';

// Import possible correspondence subject reducers.
import {
	LoadPossibleCorrespondenceSubjectsReducer,
} from './PossibleCorrespondenceSubjectReducers';

// Import possible correspondence type reducers.
import {
	LoadPossibleCorrespondenceTypesReducer,
} from './PossibleCorrespondenceTypeReducers';

// Import possible correspondence who reducers.
import {
	LoadPossibleCorrespondenceWhoReducer,
} from './PossibleCorrespondenceWhoReducers';

// Import possible doc category reducers.
import {
	LoadPossibleDocCategoriesReducer,
} from './PossibleDocCategoryReducers';

// Import possible foundation type reducers.
import {
	LoadPossibleFoundationTypesReducer,
} from './PossibleFoundationTypeReducers';

// Import possible occupancy type reducers.
import {
	LoadPossibleOccupancyTypesReducer,
} from './PossibleOccupancyTypeReducers';

// Import possible parking type reducers.
import {
	LoadPossibleParkingTypesReducer,
} from './PossibleParkingTypeReducers';

// Import possible peril reducers.
import {
	LoadPossiblePerilsReducer,
} from './PossiblePerilReducers';

// Import possible producer agency reducers.
import {
	LoadPossibleProducerAgenciesReducer,
} from './PossibleProducerAgencyReducers';

// Import possible producer agent reducers.
import {
	LoadPossibleProducerAgentsReducer,
} from './PossibleProducerAgentReducers';

// Import possible state reducers.
import {
	LoadPossibleStatesReducer
} from './PossibleStateReducers';

// Import process reducers.
import {
	StartProcessingReducer,
	EndProcessingReducer,
} from './ProcessReducers';

// Import producer reducers.
import {
	LoadProducerReducer,
} from './ProducerReducers';

// Import producer signup reducers.
import {
	LoadPossibleBusinessTypesReducer,
	LoadPossibleHeardThroughOptionsReducer,
	LoadPossibleMasterProducersReducer,
} from './ProducerSignupReducers';

// Import public policy view reducers.
import {
	ClearPublicPolicyViewDataReducer,
	LoadPublicPolicyTermsWithStatusReducer,
	LoadPublicPolicyViewDataReducer,
} from './PublicPolicyViewReducers';

// Import user meta data reducers.
import {
	LoadValidNewBusinessInceptionDateBoundariesReducer,
} from './ValidNewBusinessInceptionDateBoundariesReducers';

let reducers: { [key: string]: (state:AppState, action: Action) => AppState } = {};

// Allowed Endorsement Date Range Reducers.
reducers[ActionType.LOAD_ALLOWED_ENDORSEMENT_DATE_RANGE] = LoadAllowedEndorsementDateRangeReducer;
// App Mode Reducers.
reducers[ActionType.ADD_APP_MODE] = AddAppModeReducer;
reducers[ActionType.REMOVE_APP_MODES] = RemoveAppModesReducer;
// Claim Reducers.
reducers[ActionType.LOAD_CLAIM_PERILS] = LoadClaimPerilsReducer;
reducers[ActionType.LOAD_PREVIOUS_CLAIMS] = LoadPreviousClaimsReducer;
reducers[ActionType.SET_NEW_CLAIM] = SetNewClaimReducer;
reducers[ActionType.SET_PREVIOUS_CLAIMS] = SetPreviousClaimsReducer;
// Disqualifiers Text Reducers.
reducers[ActionType.LOAD_DISQUALIFIER_TEXT] = LoadDisqualifiersTextReducer;
// Eligibility Message Priority Reducers
reducers[ActionType.LOAD_ELIGIBILITY_MESSAGE_PRIORITIES] = LoadEligibilityMessagePrioritiesReducer;
reducers[ActionType.SELECT_ELIGIBILITY_MESSAGE_PRIORITY] = SelectEligibilityMessagePriorityReducer;
reducers[ActionType.UNSELECT_ELIGIBILITY_MESSAGE_PRIORITY] = UnselectEligibilityMessagePriorityReducer;
// Endorsement Reducers.
reducers[ActionType.LOAD_ENDORSEMENT] = LoadEndorsementReducer;
reducers[ActionType.LOAD_ENDORSEMENT_POSSIBLE_PERILS] = LoadEndorsementPossiblePerilsReducer;
// Endorsement Eligibility Status Reducers.
reducers[ActionType.LOAD_ENDORSEMENT_ELIGIBILITY_STATUS] = LoadEndorsementEligibilityStatusReducer;
// Main Navigation Link Reducers.
reducers[ActionType.LOAD_MAIN_NAVIGATION_LINKS] = LoadMainNavigationLinksReducer;
// Min Cost Per Square Foot Reducers
reducers[ActionType.LOAD_MINIMUM_COSTS_PER_SQUARE_FOOT] = LoadMinCostPerSquareFootReducer;
reducers[ActionType.SELECT_MINIMUM_COST_PER_SQUARE_FOOT] = SelectMinCostPerSquareFootReducer;
reducers[ActionType.UNSELECT_MINIMUM_COST_PER_SQUARE_FOOT] = UnselectMinCostPerSquareFootReducer;
// Min Cost Per Square Foot Version Reducers
reducers[ActionType.LOAD_MINIMUM_COST_PER_SQUARE_FOOT_VERSIONS] = LoadMinCostPerSquareFootVersionReducer;
reducers[ActionType.SELECT_MINIMUM_COST_PER_SQUARE_FOOT_VERSION] = SelectMinCostPerSquareFootVersionReducer;
reducers[ActionType.UNSELECT_MINIMUM_COST_PER_SQUARE_FOOT_VERSION] = UnselectMinCostPerSquareFootVersionReducer;
// New Business Application Preliminary Reducers.
reducers[ActionType.CLEAR_NEW_BUSINESS_APPLICATION_PRELIMINARY] = ClearNewBusinessApplicationPreliminaryReducer;
reducers[ActionType.SAVE_NEW_BUSINESS_APPLICATION_PRELIMINARY_PERILS] = SaveNewBusinessApplicationPreliminaryPerilsReducer;
reducers[ActionType.SAVE_NEW_BUSINESS_APPLICATION_PRELIMINARY_PROPERTY_ADDRESS] = SaveNewBusinessApplicationPreliminaryPropertyAddressReducer;
// New Business Application Reducers.
reducers[ActionType.LOAD_NEW_BUSINESS_APPLICATION] = LoadNewBusinessApplicationReducer;
reducers[ActionType.SELECT_NEW_BUSINESS_BUILDING] = SelectNewBusinessBuildingReducer;
reducers[ActionType.UNSELECT_NEW_BUSINESS_BUILDING] = UnselectNewBusinessBuildingReducer;
reducers[ActionType.SELECT_NEW_BUSINESS_MORTGAGEE] = SelectNewBusinessMortgageeReducer;
reducers[ActionType.UNSELECT_NEW_BUSINESS_MORTGAGEE] = UnselectNewBusinessMortgageeReducer;
reducers[ActionType.LOAD_POSSIBLE_NEW_BUSINESS_DISCLOSURE_TEXTS] = LoadPossibleNewBusinessDisclosureTextsReducer;
reducers[ActionType.LOAD_NEW_BUSINESS_APPLICATION_DOCUMENT] = LoadNewBusinessApplicationDocumentReducer;
reducers[ActionType.LOAD_NEW_BUSINESS_BINDING_AUTHORITY_ELIGIBILITY_RESULTS] = LoadNewBusinessBindingAuthorityEligibilityResultsReducer;
reducers[ActionType.LOAD_NEW_BUSINESS_POSSIBLE_PERILS] = LoadNewBusinessPossiblePerilsReducer;
// Notification Reducers.
reducers[ActionType.ADD_NOTIFICATION] = AddNotificationReducer;
reducers[ActionType.DELETE_NOTIFICATIONS] = DeleteNotificationsReducer;
reducers[ActionType.FLUSH_NOTIFICATIONS] = FlushNotificationsReducer;
// Policy Reducers.
reducers[ActionType.LOAD_POLICY_COPY_ELIGIBLITY_STATUS] = LoadPolicyCopyEligiblityStatusReducer;
// Policy Note Email Reducers.
reducers[ActionType.LOAD_POLICY_NOTE_EMAILS] = LoadPolicyNoteEmailsReducer;
// Policy Note Reducers.
reducers[ActionType.LOAD_POLICY_NOTE] = LoadPolicyNoteReducer;
reducers[ActionType.LOAD_POLICY_NOTES] = LoadPolicyNotesReducer;
reducers[ActionType.SELECT_POLICY_NOTE] = SelectPolicyNoteReducer;
reducers[ActionType.UNSELECT_POLICY_NOTE] = UnselectPolicyNoteReducer;
// Policy Term Year Reducers.
reducers[ActionType.LOAD_POLICY_TERM_YEARS] = LoadPolicyTermYearsReducer;
// Possible Building Use Reducers.
reducers[ActionType.LOAD_POSSIBLE_BUILDING_USES] = LoadPossibleBuildingUsesReducer;
// Possible Construction Reducers.
reducers[ActionType.LOAD_POSSIBLE_CONSTRUCTION_TYPES] = LoadPossibleConstructionTypesReducer;
// Possible Correspondence Recvd Or Sent Reducers.
reducers[ActionType.LOAD_POSSIBLE_CORRESPONDENCE_RECVD_OR_SENT] = LoadPossibleCorrespondenceRecvdOrSentReducer;
// Possible Correspondence Subject Reducers.
reducers[ActionType.LOAD_POSSIBLE_CORRESPONDENCE_SUBJECTS] = LoadPossibleCorrespondenceSubjectsReducer;
// Possible Correspondence Type Reducers.
reducers[ActionType.LOAD_POSSIBLE_CORRESPONDENCE_TYPES] = LoadPossibleCorrespondenceTypesReducer;
// Possible Correspondence Who Reducers.
reducers[ActionType.LOAD_POSSIBLE_CORRESPONDENCE_WHO] = LoadPossibleCorrespondenceWhoReducer;
// Possible Doc Category Reducers.
reducers[ActionType.LOAD_POSSIBLE_DOC_CATEGORIES] = LoadPossibleDocCategoriesReducer;
// Possible Foundation Type Reducers.
reducers[ActionType.LOAD_POSSIBLE_FOUNDATION_TYPES] = LoadPossibleFoundationTypesReducer;
// Possible Occupancy Type Reducers.
reducers[ActionType.LOAD_POSSIBLE_OCCUPANCY_TYPES] = LoadPossibleOccupancyTypesReducer;
// Possible Parking Type Reducers.
reducers[ActionType.LOAD_POSSIBLE_PARKING_TYPES] = LoadPossibleParkingTypesReducer;
// Possible Peril Reducers.
reducers[ActionType.LOAD_POSSIBLE_PERILS] = LoadPossiblePerilsReducer;
// Possible Producer Agency Reducers.
reducers[ActionType.LOAD_POSSIBLE_PRODUCER_AGENCIES] = LoadPossibleProducerAgenciesReducer;
// Possible Producer Agent Reducers.
reducers[ActionType.LOAD_POSSIBLE_PRODUCER_AGENTS] = LoadPossibleProducerAgentsReducer;
// Possible State Reducers.
reducers[ActionType.LOAD_POSSIBLE_STATES] = LoadPossibleStatesReducer;
// Process Reducers.
reducers[ActionType.START_PROCESSING] = StartProcessingReducer;
reducers[ActionType.END_PROCESSING] = EndProcessingReducer;
// Producer Reducers.
reducers[ActionType.LOAD_PRODUCER] = LoadProducerReducer;
// Producer Signup Reducers.
reducers[ActionType.LOAD_POSSIBLE_HEARD_THROUGH_OPTIONS] = LoadPossibleHeardThroughOptionsReducer;
reducers[ActionType.LOAD_POSSIBLE_BUSINESS_TYPES] = LoadPossibleBusinessTypesReducer;
reducers[ActionType.LOAD_POSSIBLE_MASTER_PRODUCERS] = LoadPossibleMasterProducersReducer;
// Public Policy View Reducers.
reducers[ActionType.CLEAR_PUBLIC_POLICY_VIEW_DATA] = ClearPublicPolicyViewDataReducer;
reducers[ActionType.LOAD_PUBLIC_POLICY_TERMS_WITH_STATUS] = LoadPublicPolicyTermsWithStatusReducer;
reducers[ActionType.LOAD_PUBLIC_POLICY_VIEW_DATA] = LoadPublicPolicyViewDataReducer;
// Valid New Business Inception Date Boundaries Reducers.
reducers[ActionType.LOAD_VALID_NEW_BUSINESS_INCEPTION_DATE_BOUNDARIES] = LoadValidNewBusinessInceptionDateBoundariesReducer;

export default reducers;
